import { useSearchParams } from 'react-router-dom';
import { MembershipsManagementList } from '@/pages/memberships/MembershipsManagementList';
import type { MembershipManagementMode } from '@/pages/memberships/membershipsManagementShared';

export default function MembershipsPage() {
  const [params, setParams] = useSearchParams();
  const tab: MembershipManagementMode = params.get('tab') === 'members' ? 'members' : 'memberships';

  return (
    <MembershipsManagementList
      mode={tab}
      onModeChange={(next) => {
        const nextParams = new URLSearchParams(params);
        if (next === 'memberships') nextParams.delete('tab');
        else nextParams.set('tab', 'members');
        setParams(nextParams, { replace: true });
      }}
    />
  );
}
